import { useState, type ChangeEvent, type SyntheticEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useLazySaga } from '@/domains/core/applicationState/hooks/useLazySaga';
import {
  changeAddressEmail,
  hideModal,
  hideModalSuccess,
  subscribeNewsletter,
} from '@/domains/retention/NewsletterModal/Newsletter.actions';
import {
  initialState,
  type Newsletter,
} from '@/domains/retention/NewsletterModal/Newsletter.model';
import type { SubscribeSource } from '@/domains/retention/UserProfiling/interfaces/Channel';

import type { SpartacuxRetentionState } from '../../retention.model';

const rootNewsletterSaga = () =>
  import('@/domains/retention/NewsletterModal/Newsletter.saga').then(
    (mod) => mod.rootFooterSaga,
  );

export const useNewsletter = () => {
  const dispatch = useDispatch();
  const [newsletterFocused, setNewsletterFocused] = useState(false);
  const { error, emailAddress } = useSelector<
    SpartacuxRetentionState,
    Newsletter
  >((state) => state.retention?.newsletter || initialState);

  useLazySaga('newsletter', rootNewsletterSaga, {
    condition: newsletterFocused,
  });

  const onChangeEmailAddress = (email: string) =>
    dispatch(changeAddressEmail(email));

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChangeEmailAddress(event.target.value);
  };

  const onSubscribeNewsletter = (
    e: SyntheticEvent,
    fromNewsletter: boolean,
    source: SubscribeSource,
  ) => {
    e.preventDefault();
    dispatch(subscribeNewsletter(emailAddress, fromNewsletter, source));
  };

  const onClose = () => {
    dispatch(hideModal());
  };

  const onCloseSuccessModal = () => {
    dispatch(hideModalSuccess());
  };

  const onFocus = () => {
    setNewsletterFocused(true);
  };

  return {
    emailAddress,
    error,
    onChange,
    onClose,
    onCloseSuccessModal,
    onFocus,
    onSubscribeNewsletter,
  };
};
